<template>
  <v-card>
    <v-img
      class="align-end"
      :src="productImage"
      :aspect-ratio="15 / 8"
      gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.1)"
    >
      <product-cart-price-tag
        :calculatedPrice="calculatedPrice"
        :deposit="product.deposit"
        :showPriceWithoutDph="true"
      ></product-cart-price-tag>
    </v-img>
    <v-card-title>
      {{ product.title }}
    </v-card-title>
    <v-card-subtitle v-html="productDescription"> </v-card-subtitle>
    <!-- <v-card-subtitle class="pb-0">
      <div>
        <v-icon>mdi-human-male-female-child</v-icon>
        {{ product.schoolAgeGroups }}
      </div>
      <div>
        <v-icon>mdi-gauge</v-icon> {{ product.schoolSkillLevelClients }}
      </div>
      <div><v-icon>mdi-shape</v-icon> {{ product.schoolFormType }}</div>
    </v-card-subtitle> -->

    <v-card-actions>
      <v-btn color="light-green" v-on:click="bookTheProduct" block>
        Rezervovat
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.price-tag {
  background-color: #10365c;
  color: white;
  font-weight: bold;
  display: inline-block;
  float: right;
  padding: 0.5rem;
}

.price-tag .deposit {
  font-size: 0.8rem;
  font-weight: normal;
  font-style: italic;
}

.price-tag .before-discount {
  font-weight: normal;
}
</style>

<script>
import PriceCalculator from "@/libs/PriceCalculator";
import ProductCartPriceTag from "@/components/ProductCartPriceTag";
//import moment from "moment";

export default {
  name: "CourseProductCard",

  components: {
    ProductCartPriceTag,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    productDescription() {
      if (this.product.description == null) {
        return null;
      }
      if (this.product.description.length > 150) {
        return this.product.description.substring(0, 150) + "...";
      } else {
        this.product.description;
      }
    },

    calculatedPrice: function () {
      if (
        this.product != undefined &&
        this.product.priceTables != undefined &&
        this.product.priceTables.length > 0
      ) {
        let price = PriceCalculator.findPrice(
          this.product.priceTables,
          "HOURLY",
          this.product.minLength,
          this.product.minNumOfPersons,
          this.mobConfig.schoolDiscountPercent
        );

        return price;
      } else {
        return "";
      }
    },

    checkInDate() {
      return this.$store.state.checkInDate;
    },

    productImage: function () {
      if (this.product.images == undefined) {
        return null;
      }
      if (this.product.images.length < 1) {
        return null;
      }
      return this.product.images[0];
    },

    // productSizes: function() {
    //   if (this.product.sizes == undefined) {
    //     return null;
    //   }
    //   if (this.product.sizes.length < 1) {
    //     return null;
    //   }

    //   if (this.product.sizes.length > 5) {
    //     let head = [];
    //     head.push(this.product.sizes[0]);
    //     head.push(this.product.sizes[1]);
    //     head.push("...");
    //     head.push(this.product.sizes[this.product.sizes.length - 2]);
    //     head.push(this.product.sizes[this.product.sizes.length - 1]);

    //     return head.join(", ");
    //   }

    //   return this.product.sizes.join(", ");
    // },
  },

  methods: {
    bookTheProduct() {
      this.$emit("bookProduct", this.product);
    },
  },
};
</script>
